export const color = {
  theme: ' #a6a6a6 ',
  // linear-gradient(#e66465, #9198e5);
  edit: '#ff7b54',
  submit: '#7eca9c',
  clear: '#707070',
  remove: '#d35d6e',
  search: '#1890ff',
  red: '#FF0000',
  line: '#06c755',
  logout: '#737373',
  yellow: '#F4D35E',

  //main theme focus
  blueFocus: '#2BB3E7',
  blackFocus: '#000000',
  whiteFocus: '#FFFFFF',
  redRizz: '#ec1d24',
};
